// extracted by css-extract-rspack-plugin
export default {"ul":"integrationSourceData_ul__g853p"};